import React from 'react';
import { ModalContent, ModalFooter } from 'fronton-react';
import { css } from 'linaria';
import { ButtonWithGAClickButton, ModalHeader, Typography } from 'common/components';
import { KITCHEN_ELEMENT_BLOCK } from '../../../../../kitchen-constants';
import { newKitchenHeaderCardModalTitle } from '../../new-kitchen-header-card-styles';

const projectButton = css`
  width: 100%;
`;

export const Project = ({ onCloseModal, signUpHref }: { onCloseModal: () => void; signUpHref: string; }) => (
  <>
    <ModalHeader className={newKitchenHeaderCardModalTitle} title="Сделаем бесплатный дизайн проект" />
    <ModalContent>
      <Typography variant="m" size="body_long">
        Наш дизайнер сделает проект кухни совершенно бесплатно: учтёт размеры, общий стиль интерьера и&nbsp;ваши пожелания&nbsp;&mdash; можно онлайн или в&nbsp;одном из&nbsp;магазинов Лемана ПРО.      </Typography>
    </ModalContent>
    <ModalFooter>
      <ButtonWithGAClickButton
        className={projectButton}
        onClick={onCloseModal}
        elementBlock={KITCHEN_ELEMENT_BLOCK}
        elementName="Сделаем бесплатный дизайн проект"
        elementText="Записаться на проектирование"
        href={signUpHref}
        target="_blank"
        variant="accent"
        wide
      >
        Записаться на проектирование
      </ButtonWithGAClickButton>
    </ModalFooter>
  </>
);
